import { useNavigate } from 'react-router-dom';

/** Go back in SPA history, or to `fallback` when there is nowhere to go. */
export default function BackButton({ fallback = '/', label = 'Back' }) {
  const navigate = useNavigate();
  const handleBack = () => {
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
  return (
    <button type="button" className="lng-back" onClick={handleBack} aria-label={label}>
      ←
    </button>
  );
}
